// extracted by mini-css-extract-plugin
module.exports = {"navigation-btn":"_2787e5dfdf--navigation-btn--ZEKVt","title":"_2787e5dfdf--title--HToXj"};